import React from 'react';
import { useTranslation } from 'react-i18next';
import './Hero.css';

const Hero = () => {
  const { t } = useTranslation();

  return (
    <section className="hero">
      <div className="hero-image">
        <img src="/Hero2.png" alt="Hero" />
      </div>
      <div className="hero-content">
        <h1 className="hero-title">
          <span className="hero-main-title">{t('hero.title')}</span>
        </h1>
      </div>
    </section>
  );
};

export default Hero;